<template>
  <div class="account-menu__content">
    <router-link-modified v-for="item in menu"
                          :key="item.id"
                          :to="{name: item.name, params: item.params}"
                          :class="{_disabled: item.disabled || item.inDevelopment}"
                          class="account-menu__link base-btn base-btn--outline-dark base-btn--small _blue">
      <div v-if="item.inDevelopment" class="account-menu__tooltip">
        {{ $tHeader('Section in development') }}
      </div>
      <BaseSvg v-if="item.ico"
               :name="item.ico.name"
               :width="item.ico.width"
               height="1.7rem"
               style="margin-left: 0"/>
      <template v-if="item.title">
        {{ item.title }}
      </template>
    </router-link-modified>
  </div>
</template>

<script>
  export default {
    name: 'AccountMenuAgent',
    data() {
      return {
        menu: [
          {
          //   id: 6,
          //   name: 'account-dashboard',
          //   ico: {
          //     name: 'ico-dashboard',
          //     width: '1.4rem',
          //   },
          //   inDevelopment: true
          // }, {
            id: 7,
            name: 'account-agent-resumes-base',
            title: this.$tHeader('Resume base'),
          }, {
            id: 13,
            name: 'account-vacancies-responses',
            title: this.$tHeader('My responses'),
          }, {
          //   id: 8,
          //   name: 'account-employees',
          //   title: this.$tHeader('Employees'),
          //   inDevelopment: true
          // }, {
          //   id: 10,
          //   name: 'account-balance',
          //   title: this.$tHeader('Balance')
          // }, {
            id: 11,
            name: 'account-agent-statistic',
            title: this.$tHeader('Statistic'),
          }, {
            id: 12,
            name: 'account-useful-materials',
            title: this.$tHeader('Useful materials'),
          // }, {
          //   id: 13,
          //   name: 'account-mailing',
          //   title: this.$tHeader('Mailing'),
          //   inDevelopment: true
          },
        ]
      }
    }
  }
</script>

<style lang="less">

</style>
